/**
 * resolveMpWsUrl — Vite Pages uses VITE_MP_WS_URL; local DX falls back to stub.
 * Pure: pass env bag (tests) or import.meta.env (boot).
 */

export const LOCAL_MP_STUB_WS_URL = 'ws://127.0.0.1:9998';

/**
 * @param {{ VITE_MP_WS_URL?: string }} [env]
 * @returns {string}
 */
export function resolveMpWsUrl(env = {}) {
  const raw = env && typeof env.VITE_MP_WS_URL === 'string'
    ? env.VITE_MP_WS_URL.trim()
    : '';
  return raw || LOCAL_MP_STUB_WS_URL;
}
